import moment from 'moment'

export default {
  name: 'Format',

  combination(input, digitLen) {
    let numArr = []

    for (let i = 0; i < input.length; i += digitLen) {
      numArr.push(`${ input.substring(i, i + digitLen) }`)
    }

    return numArr
  },

  getTime(ms) {
    let time = `${ ms }ms`
    if (ms > 999) {
      let sec = parseInt(ms / 1000)
      let rem = ms - (sec * 1000)

      time = `${ sec + (rem / 1000) }s`
    }

    return time
  },

  number(value, noDecimal) {
    var valFormat = value
    let withDecimal = (amount) => {
      var diff = 0

      if (noDecimal) {
        amount = Math.floor(amount)
      } else {
        diff = amount - Math.abs(amount)
      }

      return diff > 0 ? amount.toFixed(2) : amount
    }

    if (value > 999 && value < 1000000) {
      valFormat = withDecimal(value / 1000) + 'K'
    } else if (value > 999999) {
      valFormat = withDecimal(value / 1000000) + 'M'
    } else if (value > 999999999) {
      valFormat = withDecimal(value / 1000000000) + 'T'
    } else {
      valFormat = withDecimal(value)
    }

    return valFormat
  },

  fixDecimal(value) {
    if ((value + '').indexOf('.') > -1) {
      value = value.toFixed(2)
    }

    return parseFloat(value)
  },

  isUpper(c) {
    return /[A-Z]|[\u0080-\u024F]/.test(c) && c === c.toUpperCase()
  },

  toUUID(docId) {
    let uuid = docId
    let charMap = {}
    let i

    for (i = 0; i < docId.length; i++) {
      if (docId.charAt(i) == '_') {
        if (docId.charAt(i + 1)) {
          charMap[docId.charAt(i) + docId.charAt(i + 1)] =
            docId.charAt(i + 1).toUpperCase()
        }
      }
    }

    for (i in charMap) {
      uuid = uuid.replace(new RegExp(i, 'g'), charMap[i])
    }

    return uuid
  },

  toDocId(uuid) {
    let docId = uuid
    let charMap = {}

    for (let i = 0; i < uuid.length; i++) {
      if (this.isUpper(uuid.charAt(i))) {
        charMap[uuid.charAt(i)] = '_' + uuid.charAt(i).toLowerCase()
      }
    }

    for (let i in charMap) {
      docId = docId.replace(new RegExp(i, 'g'), charMap[i])
    }

    return docId
  },

  getFirstWedMonth(date) {
    let DATE_FORMAT = 'YYYY-MM-DD'
    let firstDate = moment(date, DATE_FORMAT).startOf('month')
    let DAY_POINT = 3

    while (moment(firstDate, DATE_FORMAT).day() !== DAY_POINT) {
        firstDate.add(1, 'days')
    }

    return firstDate.format(DATE_FORMAT)
  }
}